module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-UltraBoldItalic.3af6f45.eot";